<template>
  <div class="about">
    <v-sidebar />
    <div class="content-box" :class="{'content-collapse':collapse}">
      <v-header />
      <v-tags></v-tags>
      <div class="content">
        <!-- 直接渲染路由组件,不再用 transition mode="out-in" 包裹。
             原 move 过渡为 opacity 0s,本就无可见动画;而 out-in 是“等旧组件离开结束
             才挂载新组件”的门闩,一旦旧页面(如 ISBN 图书管理)离开过程中 el-table
             卸载抛错,门闩会永久卡住,表现为标签在切换、内容却停在旧页面。 -->
        <router-view v-slot="{ Component, route }">
          <component :is="Component" :key="route.path" />
        </router-view>
      </div>
    </div>
    
  </div>
</template>
<script>
import vHeader from "../components/Header";
import vSidebar from "../components/Sidebar";
import vTags from "../components/Tags.vue";
export default {
  components: {
    vHeader,
    vSidebar,
    vTags
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    }
  }
};
</script>